import { AxiosInstance } from 'axios';
import { FormulaActivityAttributes, FormulaAttributes } from '../../types/apiType';
import { PaginatedQueryParams } from '../../types/common';

export default class FormulaService {
  constructor(private axios: AxiosInstance) {}

  getListFormula = async (params: PaginatedQueryParams) => {
    const { data } = await this.axios.get('formulas', { params });
    return data;
  };

  addFormula = async (value: FormulaAttributes) => {
    const { data } = await this.axios.post('formulas', value);
    return data;
  };

  deleteFormula = async (id: string) => {
    const { data } = await this.axios.delete(`formulas/${id}`);
    return data;
  };

  updateFormula = async (id: string, value: FormulaAttributes) => {
    const { data } = await this.axios.put(`formulas/${id}`, {
      title: value.title,
      colors: value.colors,
      ph: value.ph,
      soda: value.soda,
      salt: value.salt,
      javen: value.javen,
      sut: value.sut,
      oxy: value.oxy,
      note: value.note,
      auxiliary: value.auxiliary,
      mordant: value.mordant,
    });
    return data;
  };

  printFormulaSuccess = async (params: { id: string; name: string; quantity: number }) => {
    const { data } = await this.axios.post(`formulas/${params.id}/activities`, { machine: params.name, quantity: params.quantity });
    return data;
  };

  getListFormulaActivity = async (params: PaginatedQueryParams) => {
    const { data } = await this.axios.get('formulas/activities', { params });
    return data;
  };

  updateFormulaActivity = async (id: string, value: Pick<FormulaActivityAttributes, 'colors' | 'chemicals'>) => {
    const { data } = await this.axios.put(`formulas/activities/${id}`, value);
    return data;
  };

  deleteFormulaActivity = async (id: string) => {
    const { data } = await this.axios.delete(`formulas/activities/${id}`);
    return data;
  };
}
